import { GetString } from 'fluent-react';
import React, {useState} from 'react';
import styled from 'styled-components';
import VideoTutorial from '../utilityBarItems/VideoTutorial';
import { primaryColor1 } from '../Utils';
import { RightFooterContainer } from './Grid';
import { googleAnalyticsEvent } from '../../useGoogleAnalytics';

const Root = styled(RightFooterContainer)`
  display: flex;
  justify-content: center;
`;

const Button = styled.a`
  background-color: transparent;
  color: ${primaryColor1};
  font-size: 1rem;
  border-radius: 0.625rem;
  text-transform: uppercase;
  cursor: pointer;
  padding: 1.25rem 2.5rem;
  margin-bottom: auto;
  border: 1px solid ${primaryColor1};
  display: flex;
  align-items: center;

  svg {
    fill: ${primaryColor1};
    width: 1.1rem;
    cursor: pointer;
    margin-right: 0.6rem;
    position: relative;
    top: 1px;
  }

  &:hover {
    background-color: ${primaryColor1};
    color: white;

    svg {
      fill: white;
    }
  }
`;

interface Props {
  getFluentString: GetString;
}

const TutorialVideoButton = (props: Props) => {
  const { getFluentString } = props;
  const [isVideoTutorialVisible, setVideoTutorialVisible] = useState<boolean>(false);

  const videoTutorial = isVideoTutorialVisible === true ? (
    <VideoTutorial closeModal={() => setVideoTutorialVisible(false)} initialTimeStamp={0} />
  ) : null;

  return (
    <Root>
      <Button onClick={() => {
        setVideoTutorialVisible(true);
        googleAnalyticsEvent('video', 'click', 'tutorial', 'cplanding');
      }}>
        <span dangerouslySetInnerHTML={{__html: require('../utilityBarItems/video-icon.svg')}} />
        {getFluentString('landing-bottom-nav-watch-video')}
      </Button>
      {videoTutorial}
    </Root>
  );
};

export default TutorialVideoButton;
